import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Form, Button, Stack } from '@metarouter-private/mr-mui';
import { useQuerySampleEvent, useUpdateSampleEvent } from '@ion/api';

import CenteredLoader from 'app/components/CenteredLoader';
import SampleEventForm from 'app/shared/components/sample-events/SampleEventForm';

export default function EditView({ sampleEventId, onCancel, onEditSuccess }) {
  const { sampleEvent, loading: fetching } = useQuerySampleEvent(sampleEventId);
  const [updateSampleEvent] = useUpdateSampleEvent();

  const handleSubmit = useCallback(
    async ({ name, description, eventJson }) => {
      const response = await updateSampleEvent({ id: sampleEventId, name, description, eventJson });
      if (!response.errors) {
        onEditSuccess({ eventId: sampleEventId, eventJson });
      }
    },
    [updateSampleEvent, sampleEventId, onEditSuccess]
  );

  if (fetching) {
    return <CenteredLoader />;
  }

  const defaultValues = {
    name: sampleEvent.name,
    description: sampleEvent.description,
    eventJson: sampleEvent.eventJson,
  };

  return (
    <Form onSubmit={handleSubmit} validationMode="all">
      <Stack spacing={2}>
        <SampleEventForm defaultValues={defaultValues} />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>

          <Button variant="contained" type="submit" data-test-id="confirm-update-sample-event-button">
            Save
          </Button>
        </Stack>
      </Stack>
    </Form>
  );
}

EditView.propTypes = {
  sampleEventId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onEditSuccess: PropTypes.func.isRequired,
};
